export const TableHeaders = [
  { column: 'id', label: 'ID', width: '30%', sortBy: 'text' },
  { column: 'copyText', label: 'Copy text', width: '45%', sortBy: 'text' },
  { column: 'updatedAt', label: 'Updated', width: '10%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '15%' },
];
